import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormInput } from '@shared/models/form-input';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-form-input-select',
    templateUrl: './form-input-select.component.html',
    styleUrls: ['./form-input-select.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, TranslateModule]
})
export class FormInputSelectComponent {
    @Input() field!: FormInput;
    @Input() form!: UntypedFormGroup;
    @Input() readonly = false;
    @Input() inlineLabel = false;
    @Input() isRequired = false;
    @Output() selected: EventEmitter<string> = new EventEmitter<string>();

    get Control() {
        return this.form.get(this.field.control) as UntypedFormControl;
    }

    selectOption(event: any) {
        this.selected.emit(event);
    }
}
